<div class="no-print-container">
    <div class="row page-header">
        <div class="col-12">
            <h1>
                Accountability Chart
                <small>Dynamically view the organizational accountability.</small>
                <small [hidden]="unassignedGrid.items.length === 0 && missingParentGrid.items.length === 0" style="color: firebrick">
                    Scroll down to see missing data.</small
                >
            </h1>
        </div>
    </div>
    <div [hidden]="!hasTooManyRoots">More that one employee has a udReportsTo value equal to their Hrref.</div>
    <div [hidden]="isInitialLoading || hasTooManyRoots">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <input
                        type="search"
                        class="form-control"
                        style="width: 200px; height: 32px"
                        placeholder="Search by name"
                        [(ngModel)]="search"
                        name="search"
                        (ngModelChange)="filterChart()"
                    />
                    <wj-combo-box
                        style="width: 300px"
                        [itemsSource]="trainings"
                        (selectedIndexChanged)="filterChart()"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [(ngModel)]="selectedTraining"
                        name="selectedTraining"
                    >
                    </wj-combo-box>
                    <wj-combo-box
                        style="width: 250px"
                        [itemsSource]="skills"
                        (selectedIndexChanged)="filterChart()"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [(ngModel)]="selectedSkill"
                        name="selectedSkill"
                    >
                    </wj-combo-box>
                    <button type="button" class="btn btn-primary btn-sm" (click)="printChart()" title="Print Organization Chart">
                        Print
                    </button>
                </form>
            </div>
        </div>

        <div class="row" [hidden]="unassignedGrid.items.length === 0">
            <h4 class="text-danger">Employees with no Parent Id assigned</h4>
            <div class="col-12">
                <wj-flex-grid
                    id="gridUnassigned"
                    #gridUnassigned
                    style="height: 120px"
                    (initialized)="unassignedGrid.initialize(gridUnassigned)"
                    [itemsSource]="unassignedGrid.view"
                    [keyActionTab]="'MoveAcross'"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Employee #'"
                        [binding]="'hrref'"
                        [width]="'*'"
                        [format]="'d'"
                        [dataType]="'String'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'First Name'" [binding]="'firstName'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Last Name'" [binding]="'lastName'" [width]="'*'"></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
        <div class="row" [hidden]="missingParentGrid.items.length === 0">
            <h4 class="text-danger">Employees with Parent Id that is not valid</h4>
            <div class="col-12">
                <wj-flex-grid
                    id="gridMissingParent"
                    #gridMissingParent
                    style="height: 120px"
                    (initialized)="missingParentGrid.initialize(gridMissingParent)"
                    [itemsSource]="missingParentGrid.view"
                    [keyActionTab]="'MoveAcross'"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Employee #'"
                        [binding]="'id'"
                        [width]="'*'"
                        [format]="'d'"
                        [dataType]="'String'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'First Name'" [binding]="'firstName'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Last Name'" [binding]="'lastName'" [width]="'*'"></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
</div>
<div class="chart-container"></div>
